"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Mail, Clock, CircleCheck, MessageCircle } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded" />)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const certifications = ["AASM Member", "FDA Cleared Devices", "HIPAA Compliant Clinic"];
  return <section id="footer" className="dark bg-background text-foreground pt-16 pb-8 relative">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <img src="https://dentistforsleepapnea.com/wp-content/uploads/2026/04/Mask-group-scaled.png" alt="Dentist for Sleep Apnea" className="h-12 w-auto" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Providing comfortable, CPAP-free sleep apnea and snoring treatments for adults in the greater Los Angeles area. Your trusted partner for restorative sleep.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-foreground font-sans">Quick Links</h3>
            <MenuProvider menu_id="42">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-foreground font-sans">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="w-5 h-5 text-primary shrink-0" />
                <span>2002 South Hoover Street Los Angeles, CA 90007</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="w-5 h-5 text-primary shrink-0" />
                <Link to="#" className="hover:text-primary transition-colors">(310) 858-7373</Link>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="w-5 h-5 text-primary shrink-0" />
                <Link to="#" className="hover:text-primary transition-colors">support@restoredentalcenters.com</Link>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <Clock className="w-5 h-5 text-primary shrink-0" />
                <span>Monday - Friday:<br />8:00 AM - 5:00 PM</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-foreground font-sans">Certifications</h3>
            <ul className="space-y-3">
              {certifications.map((cert, i) => <li key={i} data-index={i} className="flex items-center gap-3 text-sm text-muted-foreground">
                  <CircleCheck className="w-5 h-5 text-primary shrink-0" />
                  <span>{cert}</span>
                </li>)}
            </ul>
          </div>

        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Dentist for Sleep Apnea. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="text-xs text-muted-foreground hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="text-xs text-muted-foreground hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="fixed bottom-6 right-6 z-50">
        <Button asChild size="lg" className="rounded-full shadow-2xl bg-[var(--chart-2)] hover:bg-[var(--chart-2)]/90 text-white h-14 px-6 gap-2 border-none">
          <Link to="#">
            <MessageCircle className="w-5 h-5" />
            <span className="hidden sm:inline font-semibold">Book Free Consultation</span>
          </Link>
        </Button>
      </div>
    </section>;
}